import { useTranslation } from 'react-i18next';

import {
  FilterType,
  CustomFilterType,
  NativeFilterTypes,
} from 'design-system-web';
import { ProductType } from 'graphql-query-contracts';
import { useChannelAdminContext } from 'hooks';

import { useChargeCodesOptions } from '../../../charges-invoices/hooks';

export const useProductsServicesTableFilters = () => {
  const { t } = useTranslation();
  const { channel } = useChannelAdminContext();
  const chargeCodes = useChargeCodesOptions(channel?._id);

  const filters: (FilterType | CustomFilterType<any>)[] = [
    {
      key: 'type',
      type: NativeFilterTypes.Select,
      label: t('abp.productsTable.filters.label.type'),
      options: [
        {
          label: t('abp.productsTable.filters.product'),
          value: ProductType.ProductTypeServiceMaterials,
        },
        {
          label: t('abp.productsTable.filters.service'),
          value: ProductType.ProductTypeServiceLabour,
        },
      ],
      isPromoted: true,
    },
    {
      key: 'chargeCode',
      label: t('abp.productsTable.filters.label.chargeCode'),
      type: NativeFilterTypes.Multiselect,
      doTranslation: false,
      isPromoted: true,
      options: chargeCodes,
    },
  ];

  return {
    filters,
  };
};
